import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueScrollTo from 'vue-scrollto'
import i18n from './plugins/i18n'
import VueAnalytics from 'vue-analytics'
import meta from './plugins/meta'

import './assets/scss/main.scss';

Vue.config.productionTip = false

Vue.use(VueScrollTo)
Vue.use(i18n)
Vue.use(VueAnalytics, {
  id: 'UA-89177358-1',
  router
})
Vue.use(meta)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
